/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { render } from 'react-dom';
import Modal from './ConfirmModal';

export default class Confirm {
  constructor(props) {
    this.params = props;
    this.el = document.createElement('div');
  }

  open() {
    const confirmPromise = new Promise((resolve) => {
      render(
        <Modal
          {...this.params}
          onClose={(result) => {
            resolve(result);
          }}
        />,
        this.el
      );
    });

    return confirmPromise;
  }
}
